export const shouldUpdateScroll = () => {
  return true;
};

export const onClientEntry = () => {
  // Suppress YouTube iframe postMessage warnings
  // These are harmless cross-origin communication attempts during iframe initialization
  const originalError = console.error;
  console.error = function(...args) {
    const errorMsg = args[0]?.toString() || '';
    if (
      errorMsg.includes('postMessage') &&
      (errorMsg.includes('youtube.com') || errorMsg.includes('youtube-nocookie.com'))
    ) {
      return;
    }
    originalError.apply(console, args);
  };
};
